import styled from '@emotion/styled';
import Box from './layouts/Box';
import { variant } from 'styled-system';
import { oneOf, node, bool, string } from 'prop-types';

const PopupContainer = styled(Box)({
  position: 'relative',
  width: '-moz-fit-content',
  userSelect: 'none',
});

const Popup = styled(Box)(({ theme, borderColor, padding, hGap, vGap }) => [
  {
    position: 'absolute',
    border: '1px solid',
    borderColor: borderColor || theme?.colors?.border || 'grey',
    padding,
    zIndex: 1,
  },
  variant({
    prop: 'position',
    variants: {
      'top-left': {
        bottom: `calc(100% + ${vGap})`,
        right: `calc(100% - ${hGap})`,
      },
      'top-center': {
        bottom: `calc(100% + ${vGap})`,
        left: '50%',
        transform: 'translateX(-50%)',
      },
      'top-right': {
        bottom: `calc(100% + ${vGap})`,
        left: `calc(100% - ${hGap})`,
      },
      'right-center': {
        top: '50%',
        left: `calc(100% + ${hGap})`,
        transform: 'translateY(-50%)',
      },
      'bottom-right': {
        top: `calc(100% + ${vGap})`,
        left: `calc(100% - ${hGap})`,
      },
      'bottom-center': {
        top: `calc(100% + ${vGap})`,
        left: '50%',
        transform: 'translateX(-50%)',
      },
      'bottom-left': {
        top: `calc(100% + ${vGap})`,
        right: `calc(100% - ${hGap})`,
      },
      'left-center': {
        top: '50%',
        right: `calc(100% + ${hGap})`,
        transform: 'translateY(-50%)',
      },
    },
  }),
]);

const WithPopup = ({
  content,
  children,
  position,
  isOpen,
  hGap,
  vGap,
  ...boxProps
}) => {
  return (
    <PopupContainer>
      <div css={{ cursor: 'pointer' }}>{children}</div>
      {isOpen && (
        <Popup
          {...boxProps}
          position={position}
          hGap={hGap}
          vGap={vGap}
          bg="white"
        >
          {content}
        </Popup>
      )}
    </PopupContainer>
  );
};
WithPopup.propTypes = {
  content: node.isRequired,
  children: node.isRequired,
  position: oneOf([
    'top-left',
    'top-center',
    'top-right',
    'right-center',
    'bottom-right',
    'bottom-center',
    'bottom-left',
    'left-center',
  ]),
  isOpen: bool,
  padding: string,
  hGap: string,
  vGap: string,
};

WithPopup.defaultProps = {
  position: 'bottom-left',
  isOpen: false,
  padding: '16px 24px',
  hGap: '24px',
  vGap: '8px',
};

export default WithPopup;
